/**
 * Extrahiert den Common Name (CN) aus dem Subject-Distinguished-Name eines Zertifikats
 * (z. B. "CN=Max Mustermann, O=Firma, C=DE" -> "Max Mustermann"). Enthält das Subject kein
 * "CN=", wird es unverändert zurückgegeben (z. B. falls das Backend bereits nur den Namen liefert).
 */
export function extractCertificateCommonName(subject: string): string {
  const match = subject.match(/CN=([^,]+)/i);
  return match ? match[1].trim() : subject.trim();
}
